import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ReactiveAsteriskModule } from 'src/components/reactive-asterisk/reactive-asterisk.module';
import { SelectSearchModule } from 'src/components/select-search/select-search.module';
import { ModalModule } from 'src/shared/modal';
import { CreditNoteFormComponent } from './credit-note-form.component';
import { CreditNoteFormService } from './credit-note-form.service';

@NgModule({
  declarations: [CreditNoteFormComponent],
  providers: [CreditNoteFormService],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    ModalModule,
    ReactiveAsteriskModule,
    ReactiveFormsModule,
    SelectSearchModule,
  ]
})
export class CreditNoteFormModule { }
